import React, { useRef } from 'react';
import Slider from 'react-slick'; // Import React Slick
import 'slick-carousel/slick/slick.css'; // Import slick styles
import 'slick-carousel/slick/slick-theme.css'; // Import slick theme styles
import bhaktiMandir from "../assets/BhaktiMandir.jpg"
import varanasi from "../assets/varanasi.jpeg"
import ayodhya from "../assets/ayodhya.jpg"
import sarnath from "../assets/sarnath.jpg"
import vindhyanchal from "../assets/vindhyanchal.jpg"
import chitrakoot from "../assets/chitrakoot.jpg"


// Example data for nearby places with image URLs
const nearbyPlaces = [
  { id: 1, name: 'Bhakti Mandir', distance: '50 km', description: 'Kripalu Dham Mangarh Ashram', image: bhaktiMandir },
  { id: 2, name: 'Ayodhya', distance: '150 km', description: 'Famous for Ram Mandir', image: ayodhya },
  { id: 3, name: 'Varanasi', distance: '135 km', description: 'Known for its ghats and temples', image: varanasi },
  { id: 4, name: 'Sarnath', distance: '150 km', description: 'A Buddhist pilgrimage site', image: sarnath },
  { id: 5, name: 'Vindhyachal Temple', distance: '100 km', description: 'Famous temple dedicated to Goddess Vindhyavasini', image: vindhyanchal },
  { id: 6, name: 'Chitrakoot', distance: '120 km', description: 'Known for its religious significance', image: chitrakoot },
];

const NearbyPlacesToVisit = () => {
  const sliderRef = useRef(null); // Reference to the slider component

  // Slider settings
  const settings = {
    infinite: true, // Loop the slides
    speed: 500, // Slide transition speed
    slidesToShow: 3, // Number of slides to show
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Delay between slides
    cssEase: 'linear', // Smooth transition effect
    responsive: [
      {
        breakpoint: 1024, // Adjust for tablets
        settings: {
          slidesToShow: 2, // Show 2 slides on tablets
        },
      },
      {
        breakpoint: 600, // Adjust for mobile screens
        settings: {
          slidesToShow: 1, // Show 1 slide on mobile
        },
      },
    ],
  };

  return (
    <div className="container px-8 py-12">
      {/* Heading */}
      <h2 className="text-center text-4xl md:text-5xl text-gray-800 italic mb-4"
        style={{ fontFamily: "Tiro Devanagari Hindi, serif" }}>Nearby Cities and Attractions</h2>
      
      {/* Slider for nearby places */}
      <Slider {...settings} ref={sliderRef} className="w-full">
        {nearbyPlaces.map((place) => (
          <div key={place.id} className="flex justify-center px-4">
            <div
              className="card p-4 border-2 border-gray-300 rounded-lg hover:shadow-lg transition relative overflow-hidden group"
              style={{
                backgroundImage: `url(${place.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '450px',  // Adjust the height here
              }}
            >
              {/* Overlay for opacity */}
              <div className="absolute inset-0 bg-black opacity-40 group-hover:opacity-20 transition-opacity"></div>

              {/* Card Content */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10  ">
                <h3 className="font-semibold text-xl text-white mb-2">{place.name}</h3>
                <p className="text-sm text-white mb-4">{place.description}</p>
                <p className="text-sm text-white">{place.distance} from Prayagraj</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NearbyPlacesToVisit;
